﻿import { UTL } from "../util/classes";
import { NotifyPlus, NotifyPlusAuxFunctions, NotifyPlusStyleRecord } from "./popupPlus_Notify";
//panel_element.style.gap = "0.8em";
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
// כחול נקי (כמו ב-iOS/Android)

//console.log("AUX LOADED yes yes yes yes yes");

export class FacadePlus {
    // תפקיד מחלקה זו הוא להכיל פונקציות סטטיות מה שאמורות להקרא מקבצים אחרים
    // תפקיד מחלקה זו הוא להכיל פונקציות סטטיות מה שאמורות להקרא מקבצים אחרים
    // תפקיד מחלקה זו הוא להכיל פונקציות סטטיות מה שאמורות להקרא מקבצים אחרים
    public static async button_example_async(): Promise<void> {
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "#2c3e50";
        style_rec.fore_color = "white";
        NotifyPlus.Open("hello, i am facade async", style_rec);
        await UTL.sleep_async(200);
        NotifyPlus.Close();
    }


    public static Append_wait(p_text: string = "יש להמתין", p_display_progress_milliseconds: boolean = false): void {
        // Append_wait_overlay_invisible() :להזכירך שקיימת גם פונקציה בשם
        // Append_wait_overlay_invisible() :להזכירך שקיימת גם פונקציה בשם
        // Append_wait_overlay_invisible() :להזכירך שקיימת גם פונקציה בשם
        // Append_wait_overlay_invisible() :להזכירך שקיימת גם פונקציה בשם
        // Append_wait_overlay_invisible() :להזכירך שקיימת גם פונקציה בשם
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "#2c3e50";
        style_rec.fore_color = "white";
        style_rec.display_progress_milliseconds = p_display_progress_milliseconds;
        NotifyPlus.Open(p_text, style_rec);
    }


    public static Append_wait_overlay_invisible(p_text: string = "יש להמתין"): void {
        // באופן תקין גם אם הם כבר פתורים NotifyPlus.Open(),AnnouncePlus.Open( שים לב שבתאריך 1.5.2026 אנחנו רוצים לאפשר ביצוע
        // באופן תקין גם אם הם כבר פתורים NotifyPlus.Open(),AnnouncePlus.Open( שים לב שבתאריך 1.5.2026 אנחנו רוצים לאפשר ביצוע
        // באופן תקין גם אם הם כבר פתורים NotifyPlus.Open(),AnnouncePlus.Open( שים לב שבתאריך 1.5.2026 אנחנו רוצים לאפשר ביצוע
        // באופן תקין גם אם הם כבר פתורים NotifyPlus.Open(),AnnouncePlus.Open( שים לב שבתאריך 1.5.2026 אנחנו רוצים לאפשר ביצוע
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0)";
        style_rec.back_color = "#2c3e50";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

    public static Append_wait_to_next_page_message(p_text: string = "..שולח את הטופס לשרת. אנא המתן"): void {
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "blue";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

    public static Append_V1_WAIT(p_text: string = "..המתן"): void {
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "blue";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

    public static Append_send_form_to_server(p_text: string = "..שולח את הטופס לשרת. אנא המתן"): void {
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "blue";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

    public static Append_V2_F6(p_text: string = "יצירת שורה חדשה. המתן.."): void {
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 255, 0.1)";
        style_rec.back_color = "blue";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

    public static Append_V3_force_load(p_text: string = "מבצע פרסום הנתונים<br>כל הנתונים מהשרת"): void {
        // <br> יש להריד כנראה את
        // <br> יש להריד כנראה את
        // <br> יש להריד כנראה את
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "blue";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

    public static Append_perfrom_reload_message(p_text: string = "מבצע את טעינה<br>של כל הנתונים מהשרת"): void {
        // <br> יש להריד כנראה את
        // <br> יש להריד כנראה את
        // <br> יש להריד כנראה את
        const style_rec: NotifyPlusStyleRecord = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "15px", "#2c3e50", "black", false);
        style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        style_rec.back_color = "blue";
        style_rec.fore_color = "white";
        NotifyPlus.Open(p_text, style_rec);
    }

}
